import { render, staticRenderFns } from "./CoursesTable.vue?vue&type=template&id=239611d8&scoped=true&"
import script from "./CoursesTable.vue?vue&type=script&lang=ts&"
export * from "./CoursesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239611d8",
  null
  
)

export default component.exports